module.exports = __webpack_public_path__ + "assets/img/00086.a2bc4b81.png";